/**
 * Leave the SPA with a real document load.
 *
 * Used for the crew shell → full site bridge. The two are disjoint bundles, and
 * crossing between them via a client-side lazy transition means pulling the
 * whole desktop chunk set at once — any hiccup there (a stale module graph
 * after a deploy, a chunk that fails on a truck's connection) unmounts the tree
 * to a blank page. A document load boots the destination from scratch,
 * deterministically. Same origin, so the persisted session survives it.
 *
 * Wrapped in a function purely so it can be asserted on: `window.location` is
 * non-configurable in jsdom and cannot be spied.
 */
export function hardNavigate(path: string): void {
  window.location.assign(path)
}
